import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';

import { Button } from '@platform/ui';

import {
  IntegrationDetail,
  isDetailTab,
  type DetailTabId,
} from '../../features/integrations/integration-detail';

export const Route = createFileRoute('/integrations/$key')({
  /**
   * The open tab is in the URL, not in component state, so the list can link straight to
   * "Connect" and a reloaded page comes back where the admin left it. Anything that is not
   * one of the five tabs is dropped rather than rejected — a stale bookmark should open
   * the overview, not an error.
   */
  validateSearch: (search: Record<string, unknown>): { tab?: DetailTabId } => {
    const tab = search['tab'];
    return typeof tab === 'string' && isDetailTab(tab) ? { tab } : {};
  },
  component: IntegrationDetailPage,
});

/** `/integrations/:key` — one integration (MASTER_PLAN M3.9, Docs/API.md §2.10). */
function IntegrationDetailPage() {
  const { key } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <IntegrationDetail
      integrationKey={key}
      tab={tab ?? 'overview'}
      onTabChange={(next) => {
        void navigate({ search: { tab: next }, replace: true });
      }}
      backLink={
        <Link to="/integrations">
          <Button variant="secondary">All integrations</Button>
        </Link>
      }
    />
  );
}
